import { render, staticRenderFns } from "./ChatContextMenuItem.vue?vue&type=template&id=0d7b2eb6&scoped=true&"
import script from "./ChatContextMenuItem.vue?vue&type=script&lang=js&"
export * from "./ChatContextMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatContextMenuItem.vue?vue&type=style&index=0&id=0d7b2eb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b2eb6",
  null
  
)

export default component.exports